import packageJson from '../../package.json';

export const environment = {
  version: packageJson.version,
  production: true,
  mock: false,
  recaptchaSiteKey: '6Lcw8bQpAAAAAFE2TW7mBu9SNQ1EuxwH2bXEetcE',
  pollingStation: false,
  clientWebURL: 'https://storage.googleapis.com/public-disclosures.tzero.com/TZROP-Conversion-FAQ-Sheet.pdf',
  startRoute: [ 'welcome' ],
  useMTE: true,
  mteInit: "zEBAvaNdvdwVhXrDfMBIZji2oFzdH2pe3c22q2Q3W0U=",
  surveyLink: "",
  organization: "Voatz",
  useEmail: true,
  markSignatureAsX: true,
  is_vc: false
};
